import React from "react";
import Footer from "./footer";
import Navbar from "./navbar";

const Cancellationrefundpolicy = () => {
	return (
		<>
			<Navbar />
			<div className="approach-container">
				<div className="approach-inner">
					<h1
						style={{
							fontSize: "30px",
							fontWeight: "600",
							letterSpacing: "0.5px",
							lineHeight: "24px",
							fontFamily: "Rubik, sans-serif",
							marginBottom: "2rem",
						}}>
						Cancellation and Refund Policy
					</h1>

					<div className="approach-content">
						<div className="approach-left">
							<div className="approach-item">
								<p style={{ marginBottom: "25px" }}>
									By registering for any course on the Global Academy platform,
									you agree to the following cancellation and refund terms:
								</p>

								<ul
									className="approach-list"
									style={{
										marginBottom: "10px",
										display: "flex",
										gap: "16px",
										flexDirection: "column",
									}}>
									<li
										style={{
											marginLeft: "20px",
										}}>
										<b>
											All course registrations are final and non-refundable.
										</b>{" "}
										Once payment is completed through our authorized payment
										gateway,{" "}
										<b>
											no cancellation or refund requests will be entertained
										</b>
										, irrespective of the reason.
									</li>
									<li
										style={{
											marginLeft: "20px",
										}}>
										<p
											style={{
												marginBottom: "10px",
											}}>
											This non-refundable policy applies to all cases,
											including:
										</p>
										<ul style={{ listStyleType: "circle" }}>
											<li>Change of personal or professional plans</li>
											<li>Lack of usage after registration</li>{" "}
											<li>Dissatisfaction with course content or delivery</li>{" "}
											<li>
												Inability to access the course due to user-side
												technical issues
											</li>
										</ul>
									</li>
									<li
										style={{
											marginLeft: "20px",
										}}>
										Payments are securely processed through trusted third-party
										payment gateways. We do not have access to your financial
										information and are not liable for transaction failures
										caused by payment gateway systems or banking channels.
									</li>
									<li
										style={{
											marginLeft: "20px",
										}}>
										In the event of{" "}
										<b>technical errors resulting in duplicate payment</b>,
										users must notify us within 48 hours of the transaction.
										Verified duplicate payments will be refunded within{" "}
										<strong>7–10 business days</strong> through the original
										method of payment.
									</li>
									<li
										style={{
											marginLeft: "20px",
										}}>
										We do not entertain refunds for failure to access course
										content due to incorrect login credentials or lack of
										internet connectivity on the user’s end. Users are
										responsible for ensuring they meet technical requirements
										for accessing the platform.
									</li>
									<li
										style={{
											marginLeft: "20px",
										}}>
										Governing Law. Your use of this website and any dispute
										arising therefrom shall be governed by the laws of India and
										subject to the exclusive jurisdiction of the courts of
										Hyderabad, Telangana State, India.
									</li>
									<li
										style={{
											marginLeft: "20px",
										}}>
										<p
											style={{
												marginBottom: "10px",
											}}>
											For any payment-related concerns, you may contact our
											support team at:
										</p>{" "}
										<ul style={{ listStyleType: "circle" }}>
											<li>
												📧 <b>Email:</b> kamalakar@krishigap.com
											</li>{" "}
											<li>
												{" "}
												📞 <b>Phone:</b> [+91 9121160752]{" "}
											</li>{" "}
											<li>
												{" "}
												🌐 <b>Website:</b>{" "}
												<a href="https://globalfoodstandards.in/">
													www.globalfoodstandards.in
												</a>
											</li>
										</ul>
									</li>
								</ul>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div>
				<Footer />
			</div>
		</>
	);
};

export default Cancellationrefundpolicy;
